import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { WebsiteListView } from "@/components/knowledge/website-list-view";

interface WebsitesSearchParams {
  sourceId: string;
  sourceName?: string;
}

export const Route = createFileRoute("/workspace/$workspaceSlug/knowledge/websites")({
  validateSearch: (search: Record<string, unknown>): WebsitesSearchParams => {
    return {
      sourceId: typeof search.sourceId === "string" ? search.sourceId : "",
      sourceName: typeof search.sourceName === "string" ? search.sourceName : undefined,
    };
  },
  loader: async ({ parentMatchPromise }) => {
    const parent = await parentMatchPromise;
    const workspaceId = parent?.loaderData?.workspaceId;

    if (!workspaceId || typeof workspaceId !== "string") {
      throw new Error("Workspace ID is required");
    }

    return { workspaceId };
  },
  component: WebsitesPage,
});

function WebsitesPage() {
  const { workspaceId } = Route.useLoaderData();
  const { workspaceSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  if (!search.sourceId) {
    // Redirect back to sources if no sourceId provided
    void navigate({
      to: "/workspace/$workspaceSlug/knowledge/sources",
      params: { workspaceSlug },
    });
    return null;
  }

  return (
    <WebsiteListView
      workspaceId={workspaceId}
      sourceId={search.sourceId}
      sourceName={search.sourceName}
    />
  );
}
